import { render } from "./Top100.vue?vue&type=template&id=6a8078b4&scoped=true"
import script from "./Top100.vue?vue&type=script&lang=js"
export * from "./Top100.vue?vue&type=script&lang=js"

import "./Top100.vue?vue&type=style&index=0&id=6a8078b4&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8078b4"]])

export default __exports__